<template>
  <v-card flat>
    <v-card-title class="d-flex" :style="{ 'background-color': data.color }">
      <span class="slot__title mr-3">{{ data.class.title }}</span>
      <v-icon style="cursor: pointer" @click="onClickCloseIcon" dark>close</v-icon>
    </v-card-title>
    <v-card-text class="pa-4">
      <div class="mb-3">
        <v-icon>collections_bookmark</v-icon>
        <span>
          Mã lớp:
          <router-link :to="'/class/' + data.class.id">
            {{ data.class.code }}
          </router-link></span
        >
      </div>
      <div class="mb-3">
        <v-icon>mdi-shape</v-icon>
        <span>
          Loại buổi học:
          {{ renderSlotCategory(data.category) }}</span
        >
      </div>
      <div class="mb-3" v-if="tags.length">
        <v-icon>mdi-shape</v-icon>
        <span>
          Nhóm lớp:
          {{ data.class.tags }}</span
        >
      </div>
      <div class="mb-3">
        <v-icon>mdi-clock-outline</v-icon>
        Giờ học: {{ data.startTime | toTime }} - {{ data.endTime | toTime }}
      </div>
      <div class="mb-3">
        <v-icon>perm_contact_calendar</v-icon>
        <span v-if="data.teachers && data.teachers.length > 0">
          Giáo viên: {{ data | getTeacher }}
        </span>

        <span v-else class="text--disabled text-body-2"> Không tìm thấy dữ liệu</span>
      </div>
      <div class="mb-3">
        <v-icon>perm_contact_calendar</v-icon>
        <span> Trợ giảng: </span>
        <span v-if="data.mentors && data.mentors.length > 0">
          {{ data | getMentor }}
        </span>

        <span v-else class="text--disabled text-body-2"> Không có</span>
      </div>
      <div class="mb-3">
        <v-icon>mdi-bulletin-board</v-icon>
        <span v-if="data.room"> Phòng học: {{ data | getRoom }} </span>
        <span v-else class="text--disabled text-body-2"> Không tìm thấy dữ liệu</span>
      </div>
      <div class="mb-3">
        <v-icon>mdi-alert-outline</v-icon>
        <span v-if="data.description"> Ghi chú: {{ data.description }}</span>
        <span v-else class="text--disabled text-body-2"> Không có ghi chú</span>
      </div>
      <div>
        <v-icon>mdi-pencil</v-icon>
        <span v-if="data.class.description">
          Mô tả: {{ data.class.description | toClassDescription }}
        </span>
        <span v-else class="text--disabled text-body-2"> Không có mô tả</span>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text color="primary" :to="'/class/' + data.class.id">Xem</v-btn>
      <v-btn text color="primary" @click="onClickAttendance" v-if="role.name !== 'Student'"
        >Điểm Danh</v-btn
      >

      <class-attendance-dialog
        ref="attendanceDialog"
        :slotData="selectedSlot"
        :classData="classData"
        :attendances="attendances"
      ></class-attendance-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ClassAttendanceDialog from '@/modules/class/attendance/ClassAttendanceDialog'
import { renderSlotCategory } from '@/helpers'

export default {
  components: {
    ClassAttendanceDialog
  },
  data: () => ({
    loading: false,
    selection: 1,
    attendanceDialogState: false,
    selectedSlot: {}
  }),
  props: { data: Object },
  computed: {
    ...mapState('constant', ['slotStatus', 'slotTypes']),
    ...mapGetters('classDetail', ['classData', 'slots', 'attendances']),
    ...mapState('auth', ['user', 'role']),
    tags() {
      return (this.data.class.tags || '').split(/,\s*/)
    }
  },
  methods: {
    ...mapActions('classDetail', ['initClass']),
    renderSlotCategory(i) {
      return renderSlotCategory(i)
    },
    reserve() {
      this.loading = true
      setTimeout(() => (this.loading = false), 2000)
    },
    onClickCloseIcon() {
      this.$emit('close')
    },
    onClickAttendance() {
      this.initClass({ id: this.data.class.id }).then(res => {
        this.$refs.attendanceDialog.open()
        this.selectedSlot = this.slots.find(item => {
          let format = 'DD/MM/YYYY'
          return (
            moment(item.startTime).format(format) === moment(this.data.startTime).format(format)
          )
        })
      })
    }
  },
  filters: {
    toTime(time) {
      return moment(time).format('HH:mm')
    },
    toDate(time) {
      return moment(time).format('DD/MM/YYYY')
    },
    toClassDescription(data) {
      if (data.length > 100) {
        return data.substring(0, 100) + '...'
      }
      return data
    },
    getTeacher(data) {
      return data.teachers.map(t => t.name).join(',')
    },
    getMentor(data) {
      return data.mentors.map(t => t.name).join(',')
    },
    getRoom(data) {
      return data.room ? data.room.title : ''
    }
  }
}
</script>
<style lang="scss" scoped>
.v-icon {
  margin-right: 12px;
}
.slot__title {
  font-size: 18px;
  line-height: 21px;
  text-transform: uppercase;
  color: #ffffff;
  max-width: 250px;
  word-break: keep-all;
}
::v-deep {
  .v-card__title {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    // background-color: #ff5c93;
    padding: 12px 16px !important;
  }
  .v-card__text {
    border-bottom: 1px solid #e0e0e0;
  }
  .v-list-item__subtitle {
    .v-icon {
      font-size: 20px;
      margin-right: 20px;
    }
    a {
      text-decoration: none;
      color: #ffb300;
      cursor: pointer;
    }
    font-size: 14px;
    line-height: 16px;
    font-weight: bold;
    color: #757575;
    margin-bottom: 16px;
  }
}
</style>
